// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbVector } from "../engine/tbVector";
import { tgfFunctions } from "../framework/tgfFunctions";
import { BalloonSettings } from "../settings/Settings";
import { PhysicsObject } from "./PhysicsObject";
import { physics } from "./SceneController";
import { playController } from "./gameController";
export function BalloonObjectDefault(def, uid, x, y, angle, container) {
    BalloonObjectDefault.uber.constructor.call(this, def, uid, x, y, angle, container);
    this.collTimer = 1; // >0 == going to check for joints, <0 == going to check for collisions/supports, 0 == idle
    this.dying = false;
    this.tempAccel = 0;
    this._initialJointCheck = false;
    this.hasJoint = false;
    this.hasWokenSurroundingObjects = false;
}
tgfFunctions.inherit(BalloonObjectDefault, PhysicsObject);
BalloonObjectDefault.prototype.isActive = function () {
    BalloonObjectDefault.uber.isActive(false);
};
BalloonObjectDefault.prototype.physicsStep = function () {
    if (this.dying == true) {
        if (this.image)
            this.image.setScale(this.image.scaleX * (0.96 * BalloonSettings.shrinkSpeed), this.image.scaleY * (0.96 * BalloonSettings.shrinkSpeed));
        this.tempAccel += 0.11 * BalloonSettings.accelerationSpeed;
        this.y -= this.tempAccel;
        if (this.y <= -250 || (this.image && this.image.scaleX < 0.0005)) {
            this.destroy();
            return;
        }
    }
};
BalloonObjectDefault.prototype.step = function (timePassed) {
    'use strict';
    if (!this)
        return;
    if (this._initialJointCheck === false) {
        this.hasJoint = this._checkForJoints();
        this._initialJointCheck = true;
    }
    // Explanation:
    // - The collTimer is set to 1 every time a collision is detected
    // - It counts up every frame, so if no collision occurs, it keeps counting
    // - If it reaches 30, it checks if there is a joint
    // If there is a joint, then reset back to 1 (this is so we don't iterate through an array every frame...)
    // - If there is no joint, then it counts to -30 from -1
    // - At -30, it performs a raycast to see if there's anything above the balloon
    // - If there isn't, it destroys itself
    // - If there is, it resets the counter back to 0, and begins again
    // Don't judge.
    if (this.dying == false) {
        if (this.collTimer >= 1) {
            this.collTimer += 1;
            if (this.collTimer >= 30)
                this.collTimer = -1;
        }
        else if (this.collTimer == -1) {
            if (this.hasJoint == false) {
                this.collTimer = -2;
            }
            else if (this._checkForJoints()) {
                this.collTimer = 1;
            }
            else {
                this.collTimer = -2;
            }
            ;
        }
        else if (this.collTimer <= -2) {
            this.collTimer--;
            if (this.collTimer < -30) {
                var placeToPlaceIt = new tbVector(this.x, this.y);
                var impact = physics.rayCast({ x: placeToPlaceIt.x - 1, y: placeToPlaceIt.y - 3 }, { x: placeToPlaceIt.x + 1, y: placeToPlaceIt.y - 2 });
                if (impact.hit == true) {
                    this.collTimer = 1;
                }
                else {
                    //this.destroy();
                    //this.setToIdle();
                    this.dying = true;
                }
            }
        }
    }
};
BalloonObjectDefault.prototype._stopTimer = function () {
    this.collTimer = 0;
};
BalloonObjectDefault.prototype._checkForJoints = function () {
    var joints = playController.sceneController.jointList;
    if (!joints)
        return false;
    for (var i = 0; i < joints.length; i++) {
        if (joints[i].one === this.id || joints[i].two === this.id) {
            return true;
        }
    }
    this.hasJoint = false;
    return false;
};
